import { AccordionSummary, Box, InputLabel, styled, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import environment from "../../../environments/environment";
// Styled Parent Container with theme applied
export const StyledParentContainer = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        display: "flex",
        flexShrink: 0,
        width: "100%",
        padding: "12px",
        backgroundColor: environment.generalSettings ? "rgba(255, 255, 255, 0.3)" : "#EAF4F8",
        borderRadius: "0px",
        marginBottom: "15px", 
    };
});

// Styled Child Container with theme applied
export const StyledOneChildContainer = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        display: "flex",
        width: "100%",
        borderRadius: "0px",
        border: "1px solid #D0D4D8",
        backgroundColor:  environment.generalSettings ? "rgba(255, 255, 255, 0.5)": "#FFF",
        boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.05)",
        flexShrink: 0,
        padding: "10px",
        boxSizing: "border-box",
        fontFamily: "Montserrat",
        fontSize: "26px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "120%",
        letterSpacing: "-0.5px",
    };
});

// Styled Header with theme applied
export const StyledHeader = styled(Typography)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        display: "flex",
        width: "100%",
        height: "50px",
        padding: "9px 40px",
        alignItems: "center",
        flexShrink: 0,
        borderRadius: "0px",
        background: "#4598A6",
        color: "white",
        fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
        fontSize: "26px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "120%",
        letterSpacing: "-0.5px",
        boxSizing: "border-box",
        marginBottom: "15px",
    };
});

// Section Title with theme applied
export const SectionTitle = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        fontFamily: "Montserrat, sans-serif",
        fontSize: "26px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "120%",
        letterSpacing: "-0.5px", 
        background: "linear-gradient(180deg, #E9F3F5 0%, #FFF 100%)",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: "15px",
    };
});

// Sub Section Title with theme applied
export const SubSectionTitle = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        fontFamily: "Montserrat, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        lineHeight: "120%",
        letterSpacing: "-0.5px",
        borderRadius: "0px",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
    };
});

// Styled Two Child Container with theme applied
export const StyledTwoChildContainer = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        width: "100%",
        flexShrink: 0, 
        border: "1px solid var(--Border-Color, #DADCDC)",
        background:  environment.generalSettings ?  "rgba(255, 255, 255, 0.7)" : "#FDFDFD",
        boxSizing: "border-box",
    };
});

// Styled Summary Container with theme applied
export const StyledSummaryContainer = styled(Box)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        width: "100%",
        flexShrink: 0, 
    border: "1px solid var(--Border-Color, #DADCDC)",
    background: environment.generalSettings ? "rgba(255, 255, 255, 0.7)" : "#EAF4F8",
    boxSizing: "border-box",
    };
});

// Styled Input Label with theme applied
export const StyledInputLabel = styled(InputLabel)(({ theme }) => {
    const themeDetails = useSelector((state: RootState) => state?.themes);
    return {
        letterSpacing: "1px",
        fontWeight: 400,
        fontSize: "22px",
        lineHeight: "120%",
        color: "black !important",
        fontFamily: "Inter, sans-serif",
    };
});

export const CustomAccordionSummary = styled(AccordionSummary)`
  display: flex !important;
  padding: 8px !important;
  height: 5px !important;
  justify-content: space-between !important;
  align-items: center !important;
  flex: 1 0 0 !important;
  border-bottom: 1px solid var(--Accordion-border, #E0E0E0) !important;
  background: linear-gradient(180deg, #E9F3F5 0%, #FFF 100%) !important;
  color:black !important;
`;